import * as firebase from "firebase";
import { push } from "redux-little-router";

import {
  clearUser,
  firebaseAuthDone,
  fetchUserExtraProfileData,
  showCookiesBar,
  setRawUser,
  setSSRUserFlag,
} from "../actions/userActions";
import { checkIsNewUser, addNewUser } from "./firebaseRealtimeDb";
import mixpanel from "../services/mixpanel";
import { showAlert } from "../actions";
import { currentWindowOrigin } from "../util/windowLocation";
import windowDataLayer from "../util/windowDataLayer";

//Initialize Firebase
const firebaseapp = firebase.initializeApp({
  apiKey: "AIzaSyCO9O_O35iYOrs0cxMee3MuKLHNooUTqHI",
  authDomain: "casemasters-a1545.firebaseapp.com",
  databaseURL: "https://casemasters-a1545.firebaseio.com",
  projectId: "casemasters-a1545",
  storageBucket: "casemasters-a1545.appspot.com",
  messagingSenderId: "1093933244416",
});

export const refreshToken = _ => {
  let currentUser = firebaseapp.auth().currentUser;
  //check if current token is invalid and request a new token
  if (currentUser) {
    currentUser.getIdToken(true);
  }
};

const fireSignedupEvent = userId =>
  checkIsNewUser(userId).then(isSignedupUser => {
    if (!isSignedupUser) {
      addNewUser(userId).then(() => {
        windowDataLayer.push({ event: "signup" });
        let extraParameters = JSON.parse(localStorage.getItem("utmParamters"));
        mixpanel.people.set_once(extraParameters, trackSettingUtmParams);
      });
    }
  });

const trackSettingUtmParams = () => mixpanel.track("utmParams.set");

const storeCookiesBarVisitedCookie = () => {
  const date = new Date();
  const oneDayInMillisec = 1 * 24 * 60 * 60 * 1000;
  date.setTime(date.getTime() + oneDayInMillisec * 60);
  const expires = "; expires=" + date.toUTCString();

  document.cookie = "cookiesBarVisited=1" + expires;
};

const cookieExists = cookieName => document.cookie.split(";").filter(item => item.includes(cookieName)).length > 0;

export const watchAuth = dispatch =>
  firebaseapp.auth().onAuthStateChanged(user => {
    if (user) {
      fireSignedupEvent(user.uid);
      dispatch(setRawUser(user));
      dispatch(fetchUserExtraProfileData(user.uid));
      dispatch(firebaseAuthDone(false));
      windowDataLayer.push({ event: "signin" });
      handleRedirectionToIntendedRoute(dispatch);
    } else {
      dispatch(clearUser());
      dispatch(firebaseAuthDone(true));
    }
    dispatch(setSSRUserFlag(false));
    if (!cookieExists("cookiesBarVisited")) {
      dispatch(showCookiesBar());
      storeCookiesBarVisitedCookie();
    }
  });

export const watchTokenChange = dispatch =>
  firebaseapp.auth().onIdTokenChanged(user => {
    if (user) {
      dispatch(setRawUser(user));
    } else {
      dispatch(clearUser());
    }
  });

export const watchRedirectResult = dispatch =>
  firebaseapp
    .auth()
    .getRedirectResult()
    .catch(error => {
      mixpanel.track("redirect failed", error);
      switch (error.code) {
        case "auth/account-exists-with-different-credential":
          dispatch(
            showAlert(
              "An account already exists with this email. please login with email and password instead",
              "error",
              20000
            )
          );
          break;

        default:
          dispatch(showAlert("An error occured. Please try again later.", "error"));
          break;
      }
    });

function handleRedirectionToIntendedRoute(dispatch) {
  if (sessionStorage) {
    const routeBeforeLogin = sessionStorage.getItem("storeLastRoute");
    if (routeBeforeLogin) {
      sessionStorage.setItem("storeLastRoute", "");
      dispatch(push(routeBeforeLogin));
    }
  }
}

export function sendVerificationEmail() {
  const user = firebaseapp.auth().currentUser;
  const actionCodeSettings = {
    url: currentWindowOrigin(),
  };

  user.sendEmailVerification(actionCodeSettings);
}

export default firebaseapp;



// WEBPACK FOOTER //
// ./src/services/firebase.js